import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return (
    <div className="d-flex justify-content-center mt-5 text-center">
      <section>
        <h1>Unauthorized</h1>
        <br />
        <p className="fs-5">You do not have access to the requested page.</p>
        <div className="flexGrow">
          <button className="btn btn-secondary" onClick={goBack}>
            Go Back
          </button>
        </div>
      </section>
    </div>
  );
};

export default Unauthorized;
